import { OWDataType } from "@multiweb/types/contracts";
import { CaseInsensitiveMap } from "../../../../../../Global/Base/DataTypes/CaseInsensitiveMap";
import { StringUtils } from "../../../../../../Global/Base/Utils/StringUtils";
import { ModelDescriptionsManager } from "../../../../../../OW.Remoting/Remoting/Cache/ClassDescriptionCache/ModelDescriptionsManager";
import { EnumType } from "../../../../../../OW.Remoting/Remoting/DataTypes/Enums";
import { OWManager } from "../../../../../../OW.Remoting/Remoting/OWManager";
import { Edit } from "../../../../../UI.BaseControls/Edit";
import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { IFilterUserValue } from "../FilterInterfaces";
import { logger } from "../logger";

export class EnumFilterEdit extends Edit implements IFilterUserValue {
    private _enumType: EnumType;
    // @ts-ignore // nevyužito, ale ponecháno
    private _enumName: string;
    private static _enumsType: CaseInsensitiveMap<EnumType> = new CaseInsensitiveMap<EnumType>();

    private _className: string;
    private _attrName: string;
    private _filterType: string;

    protected override _constructor(): void {
        super._constructor();
        this.classList.add("EnumFilterEdit");
    }

    protected static override get observedAttributes(): string[] {
        return ["data-classname", "data-attrname", "filter-item-id"].concat(Edit.observedAttributes);
    }

    public override set value(val: any) {
        this.controlValue = val;
    }

    public override get value(): any {
        const val = this.controlValue;
        const vals = [-1]; //pomocná hodnota pro použití v podmínce. Ošetřuje situace, kdy není vybraná žádná hodnota a podmínka by obsahovala prázdnou množinu, což by vedlo k chybě.

        if (!val)
            return null;
        if (!this._enumType)
            return vals.join(", ");

        for (const item of this._enumType.descriptions) {
            if (this._compareFnc(val, item.Description))
                vals.push(item.IntValue);
        }

        return vals.join(", ");
    }

    public get userValue(): any {
        return this.controlValue;
    }

    public set userValue(v: any) {
        this.value = v;
    }

    protected override attributeChangedCallback(attrName: string, oldVal: string, newVal: string): void {
        super.attributeChangedCallback(attrName, oldVal, newVal);

        switch (attrName) {
            case "data-classname":
                this._className = newVal;
                if (!this._loadSyncEnumInfo())
                    this._loadEnumInfo();
                break;
            case "data-attrname":
                this._attrName = newVal;
                if (!this._loadSyncEnumInfo())
                    this._loadEnumInfo();
                break;
            case "filter-item-id":
                this._filterType = newVal;
                break;
        }
    }

    protected _compareFnc(value: string, enumValue: string): boolean {
        enumValue = StringUtils.removeAccents(enumValue.toUpperCase());
        value = StringUtils.removeAccents(value.toUpperCase());
        value = value.split("*").join(".*?");

        //is funguje jako contain pokud je použita *
        const filterType = (this._filterType == "is" || this._filterType == "not_is") && value.indexOf("*") > -1 ? "contain" : this._filterType;
        switch (filterType) {
            case "start_with":
            case "not_start_with":
                return enumValue.search(`^${value}`) > -1;
            case "end_with":
            case "not_end_with":
                return enumValue.search(`${value}$`) > -1;
            case "is":
            case "not_is":
                return enumValue == value;
            default:
                return enumValue.search(value) != -1;
        }
    }

    private _loadSyncEnumInfo(): boolean {
        if (!this._attrName || !this._className)
            return false;
        const index = `${this._className}|${this._attrName}`; // `
        if (EnumFilterEdit._enumsType.has(index)) {
            this._enumType = EnumFilterEdit._enumsType.get(index);

            return true;
        }

        return false;
    }

    private async _loadEnumInfo(): Promise<void> {
        if (!this._attrName || !this._className)
            return;

        const attrInfo = await ModelDescriptionsManager.instance.getAttributesInfo(this._className, [this._attrName]);

        if (!attrInfo || attrInfo.length == 0) {
            logger.error("Attribute info not loaded");
            return;
        }

        if (attrInfo[0].type !== OWDataType.enum) {
            logger.error("Input type is not enum (%s)", attrInfo[0].type);
            return;
        }

        const enumName = attrInfo[0].additionalTypeName;
        this._enumName = enumName;

        this._enumType = await OWManager.getEnum(enumName);
        EnumFilterEdit._enumsType.set(`${this._className}|${this._attrName}`, this._enumType);
    }
}

registerCustomElement("tsc-EnumFilterEdit", EnumFilterEdit);
